

import { Checkbox, Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import { LayoutTabla } from "../../layout"
import { AlertScreen } from "../components/AlertScreen"
import { useItemspagoStore } from "../../../store"
import { useNavigate } from "react-router-dom"






export const TablaItemsCompra = ({ data, selected, handleSelectAllClick, handleClick, isSelected, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const { totalItemsPago } = useItemspagoStore();


    const handleVerStock = (e, id) => {
        e.stopPropagation();
        navigate(`/admin/producto/${id}/stock`)
    }



    return (

        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalItemsPago / 50)} disabled={Math.ceil(totalItemsPago / 50) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell style={{padding:4, width:'7%'}}>
                            <Checkbox color="secondary"
                                indeterminate={ selected.length > 0 && selected.length < data.length }
                                checked={ data.length > 0 && selected.length === data.length }
                                onChange={ handleSelectAllClick }
                            />
                        </TableCell>
                        <TableCell sx={{width:'25%'}}>Producto</TableCell>
                        <TableCell sx={{width:'15%'}}>Cantidad</TableCell>
                        <TableCell sx={{width:'20%'}}>Granja</TableCell>
                        <TableCell sx={{width:'20%'}}>Stock Total</TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (d) => (
                        <TableRow key={d._id} sx={{padding:0}} onClick={ (_) => handleClick(d._id) }> 
                            <TableCell>
                                <Checkbox color="primary" checked={ isSelected(d._id) } />
                            </TableCell>
                            <TableCell onClick={(e) => handleVerStock(e, d.producto._id) } sx={{cursor:'pointer'}}>
                                { d.producto.nombre }
                            </TableCell>
                            <TableCell>{ d.cantidad }</TableCell>
                            <TableCell>{ d.granja.nombre }</TableCell>
                            <TableCell>{ d.stockTotal }</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        : <AlertScreen title="No hay items de compra por el momento..." />
        }
        </>
    )
}
